export default __webpack_public_path__ + "static/media/Deepshikha.f934db72.webp";